import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import "./lib/i18n";

createRoot(document.getElementById("root")!).render(<App />);
// Web Vitals are started from App.tsx after Sentry is initialized so the
// SDK is ready to receive the first LCP/INP/CLS sample.
